import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { BusinessServiceFilter, SiteFilter, StatusFilter, TimeRangeFilter } from '../../filters';
import { AgentListPanel } from '../../panels';

export const pageId = 'agents';

export default function AgentsPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`nPoints`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <BusinessServiceFilter />
                    <SiteFilter />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <AgentListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
